import { useCurrentElement } from '@vueuse/core'
import { notifyCloseDialog } from '@corp/helpers/events'

export function useCloseDialog () {
  const el = useCurrentElement<HTMLElement>()
  return (event: Event | undefined) => notifyCloseDialog(el.value, event)
}
